import { render, staticRenderFns } from "./manualWrapper.vue?vue&type=template&id=e8b48ac6&scoped=true&lang=html&"
import script from "./manualWrapper.vue?vue&type=script&lang=js&"
export * from "./manualWrapper.vue?vue&type=script&lang=js&"
import style0 from "./manualWrapper.vue?vue&type=style&index=0&id=e8b48ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b48ac6",
  null
  
)

export default component.exports